var SCM = SCM || {};

SCM.trapFocus = (function ($) {
    var retainFocus = {
        publicTrapFocus: publicTrapFocus,
        getModalVisibleAndFocusableElements: _getModalVisibleAndFocusableElements
    };

    return retainFocus;

    function publicTrapFocus($modal, $closeBtn, $lastActiveElement) {
        _initModalTrapFocus($modal, $closeBtn, $lastActiveElement);
    }

    function _getModalVisibleAndFocusableElements($modal) {
        var focusableElements = $modal.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input, div[tabindex=0]');
        var visibleElements = focusableElements.filter(':visible');
        return visibleElements;
    }

    function _initModalTrapFocus($modal, $closeBtn, lastActiveElement) {
        var KEYCODE_TAB = 9;
        $modal.keydown(function (e) {
            if (e.key === 'Escape') {
                lastActiveElement.focus();
            }

            var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

            if (!isTabPressed) {
                return;
            }

            var visibleElements = _getModalVisibleAndFocusableElements($modal);
            var firstFocusableElement = visibleElements[0];
            var lastFocusableElement = visibleElements[visibleElements.length - 1];

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            }
            else /* tab */ {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });

        $closeBtn.on('click', function () {
            lastActiveElement.focus();
        });
    }
})(jQuery);